import { WorkflowDefaultStepBlock } from '~/core/shared/types';
import { SharedBlockProps } from '../types/SharedBlockProps';

export const getKeyForBlock = (
  block: WorkflowDefaultStepBlock & SharedBlockProps,
  defaultKey: string | number,
): string | number => {
  let key = block.key ?? null;

  if (key) {
    return key;
  }

  key = `${defaultKey}`;

  switch (block.type) {
    case 'content':
      key += block.description?.toString() ?? defaultKey;
      break;

    case 'form-field':
      key += block.name;
      break;

    default:
  }

  return key;
};
